module.exports = __webpack_public_path__ + "static/smile-decal-ae4137394e573ab52fa22f49d4e0586f.png";